/* Copyright (c) Trimble Inc. All rights reserved. */

import { SvgIcon, SvgIconProps } from "@material-ui/core";
import React, { memo } from "react";

export const SubscriptionRequestIcon: React.FC<SvgIconProps> = memo((props) => {
  return (
    <SvgIcon {...props} viewBox="0 0 24 24" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.5449 5.37025L15.1955 3.33252L18.8468 5.37025L15.1955 7.40799L11.5449 5.37025Z"
        fill="inherit"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.8619 12.3254L19.2623 14.4224L19.343 18.579L22.94 16.3805L22.8619 12.3254Z"
        fill="inherit"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.1174 18.6492L7.4668 16.6095V12.4575L11.1174 14.4953V18.6492Z"
        fill="inherit"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.0949 13.9177L7.44434 11.878V7.7267L11.0949 5.68896L14.7462 7.7267L11.0949 9.76443V13.9177Z"
        fill="inherit"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.6982 7.68373L19.3488 5.646L23.0001 7.68373L19.3488 9.72147L15.6982 7.68373Z"
        fill="inherit"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.2219 16.2175L11.5713 14.1778V10.0258L15.2219 7.98877L18.8725 10.0258L15.2219 12.0636V16.2175Z"
        fill="inherit"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.8733 10.0259L15.2227 12.0636V16.2175L18.8726 14.0783L18.8733 10.0259Z"
        fill="inherit"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.2229 21.0003L11.5723 18.9605V14.8086L15.2229 16.8463V21.0003Z"
        fill="inherit"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.8733 14.8086L15.2227 16.8463V21.0003L18.8726 18.861L18.8733 14.8086Z"
        fill="inherit"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.9999 7.68506L19.3486 9.72279V13.8761L22.9986 11.7375L22.9999 7.68506Z"
        fill="inherit"
      />
      <path
        d="M6.51271 4.74947H5.06544V3.42691C5.06544 3.0632 4.7398 2.76562 4.3418 2.76562C3.9438 2.76562 3.61817 3.0632 3.61817 3.42691V4.74947H2.1709C1.7729 4.74947 1.44727 5.04705 1.44727 5.41075C1.44727 5.77446 1.7729 6.07204 2.1709 6.07204H3.61817V7.3946C3.61817 7.7583 3.9438 8.05588 4.3418 8.05588C4.7398 8.05588 5.06544 7.7583 5.06544 7.3946V6.07204H6.51271C6.91071 6.07204 7.23634 5.77446 7.23634 5.41075C7.23634 5.04705 6.91071 4.74947 6.51271 4.74947Z"
        fill="inherit"
      />
    </SvgIcon>
  );
});

export default SubscriptionRequestIcon;
